module.exports = __webpack_public_path__ + "static/img/ys2.f759fe5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ys2.jpg
// module id = BAmb
// module chunks = 2